import { Button, Modal } from 'antd';

import styles from './LowPricingScoreModal.module.scss';

type Props = {
  isOpened: boolean;
  packNames: string[];
  isLoading?: boolean;
  handleCancel: () => void;
  handleSaveAnyway: () => void;
};

export const LowPricingScoreModal = ({
  isOpened,
  packNames,
  isLoading,
  handleCancel,
  handleSaveAnyway,
}: Props) => (
  <Modal
    open={isOpened}
    title="Low pricing scores"
    onCancel={handleCancel}
    footer={[
      <Button size="large" key="cancel" type="ghost" onClick={handleCancel}>
        Cancel
      </Button>,
      <Button
        key="save"
        size="large"
        type="primary"
        onClick={handleSaveAnyway}
        loading={isLoading}
      >
        Save anyway
      </Button>,
    ]}
  >
    <p>The following packages have a pricing score below 50:</p>
    <ul className={styles.packList}>
      {packNames.map((name) => (
        <li key={name}>{name}</li>
      ))}
    </ul>
    <p>Are you sure you want to save this configuration?</p>
  </Modal>
);
